import { ICG2Guidelines, ICGG2Report } from '@fortem-monorepo/web-sdk'

export const emptyTotals = (): Record<ICG2Guidelines.GuidelineStatus, number> => ({
  hard: 0,
  soft: 0,
  ok: 0,
  failed: 0,
})

export const getValueColumn = (result: ICGG2Report.GuidelineResult) => {
  return (
    result.guideline.value_column ??
    result.issues.find((issue) => issue.value_column)?.value_column ??
    'Value'
  )
}

export const getTableLabel = (table: string) => {
  return table
    .split('.')
    .map((part) => part.replaceAll('_', ' '))
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' / ')
}

export const getCellStatusLabel = (status?: ICG2Guidelines.GuidelineStatus | null) => {
  switch (status) {
    case 'hard':
      return 'Hard'
    case 'soft':
      return 'Soft'
    case 'ok':
      return 'Ok'
    case 'failed':
      return 'Issue'
    default:
      return 'Issue'
  }
}

export const getCellStatusBadgeTheme = (status?: ICG2Guidelines.GuidelineStatus | null) => {
  switch (status) {
    case 'hard':
      return 'destructive'
    case 'soft':
      return 'warning'
    case 'ok':
      return 'success'
    case 'failed':
      return 'warning'
    default:
      return 'warning'
  }
}

export const formatIdentifierValue = (value: unknown) => {
  if (value === undefined || value === null || value === '') {
    return '-'
  }

  return String(value)
}
